var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13398 1.5C3.51888 0.833333 4.48113 0.833333 4.86603 1.5L6.59808 4.5C6.98298 5.16667 6.50185 6 5.73205 6H2.26795C1.49815 6 1.01702 5.16667 1.40192 4.5L3.13398 1.5Z",
    fill: "#ADB3C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86603 13.5C4.48112 14.1667 3.51887 14.1667 3.13397 13.5L1.40192 10.5C1.01702 9.83333 1.49815 9 2.26795 9L5.73205 9C6.50185 9 6.98298 9.83333 6.59808 10.5L4.86603 13.5Z",
    fill: "#ADB3C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortIcon);
export default __webpack_public_path__ + "static/media/TableSortIcon.53b4d96b0c189ca6ea2becc19b0a0886.svg";
export { ForwardRef as ReactComponent };